<template>
  <v-container
    fluid
    class="pa-0"
  >
    <div>
      <h3>
        {{ $t('employee.download_template') }}
      </h3>
      <h4 class="text-decoration-underline py-3">
        <a :href="`/employee_template.csv`">{{ $t('employee.download') }}</a>
      </h4>
    </div>
    <v-row>
      <v-col md="6">
        <v-file-input
          ref="csvUpload"
          class="mt-2"
          :label="$t('employee.upload_csv')"
          accept="text/csv"
          dense
          outlined
          chips
          hide-details="auto"
          :rules="fileFormatRule"
          @click="$event.target.value=''"
          @change="handleFileUpload"
        />
        <span
          v-if="noFile"
          class="ml-8 v-messages__message error--text"
        >{{ $t('employee.no_csv') }}</span>
      </v-col>
      <v-col
        v-if="parsed"
        cols="12"
      >
        <v-card>
          <v-card-title>
            <p
              style="display: inherit;"
              class="text-decoration-underline primary--text"
            >
              [{{ fileName }}]
            </p>
            <p v-if="noData">
              {{ $t('employee.csv_no_data') }}
            </p>
            <p v-else>
              {{ isHeaderMatch ? $t('employee.csv_title_valid') : $t('employee.csv_title_invalid') }}
            </p>
          </v-card-title>
          <v-card-text class="px-0">
            <v-data-table
              v-if="isHeaderMatch"
              :headers="headers"
              :items="items"
              :items-per-page="10"
            />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Encoding from 'encoding-japanese'
import csv from 'csvtojson'
export default {
  props: {
    fileUploaded: {
      type: Boolean,
      required: true
    },
    noFile: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      fileInput: '',
      parsed: false,
      fileName: '',
      headers: [],
      items: [],
      defaultHeader: ['姓', '名', '姓（カナ）', '名（カナ）', '生年月日', '性別', '電話番号', 'メールアドレス'],
      isHeaderMatch: false,
      wrongFileFormat: false,
      noData: false
    }
  },

  computed: {
    /**
     * @desc Validate file format
     * */
    fileFormatRule() {
      return [
        !this.wrongFileFormat || this.$t('common.invalid_file_format')
      ]
    },
  },
  watch: {
    isHeaderMatch() {
      this.$emit('headerMatch', this.isHeaderMatch)
    },
    items: {
      handler() {
        this.$emit('dataUploaded', this.items)
      },
      deep: true
    },
    fileUploaded: {
      handler() {
        if (this.fileUploaded) {
          this.$refs.csvUpload.reset()
          this.$emit('dataCleared')
        }
      },
      deep: true
    }
  },

  methods: {
    /**
     * @desc To handle CSV file upload, encode, and convert to array
     * */
    handleFileUpload(file) {
      if(file) {
        if (file.type === 'text/csv') {
          this.parsed = false
          this.headers = []
          this.items = []
          this.isHeaderMatch = false
          let reader = new FileReader()
          reader.readAsArrayBuffer(file)
          reader.onload = (e) => {
            let codes = new Uint8Array(e.target.result)
            let detectedEncoding = Encoding.detect(codes)
            try {
              let unicodeString = Encoding.convert(codes, {
                to: 'unicode',
                from: detectedEncoding,
                type: 'string'
              })
              csv()
                .fromString(unicodeString)
                .then((results)=>{
                  this.onParsingComplete(results, file)
                })
            } catch (e) {
              console.warn(e)
            }
          }
          reader.onerror = function (e) {
            console.warn(e)
          }
        } else {
          this.wrongFileFormat = true
        }
      } else {
        this.wrongFileFormat = false
        this.parsed = false
        this.headers = []
        this.items = []
        this.isHeaderMatch = false
      }
    },
    /**
     * @desc TO correctly validate csv parsed data
     * */
    onParsingComplete(results, file) {
      this.fileName = file.name
      if (results.length > 0) {
        this.noData = false
        this.parsed = true
        const headerValues = Object.keys(results[0])
        const isHeaderMatch = this.defaultHeader.every(x => headerValues.includes(x))
        if (isHeaderMatch) {
          const index = headerValues.length
          headerValues.forEach((x, i) => {
            this.headers.push({
              text: x, align: 'center', divider: index - 1 !== i, value: x, width: '100px'
            })
          })
        }
        this.items = results
        this.isHeaderMatch = isHeaderMatch
      } else {
        this.noData = true
        this.parsed = true
      }
    }
  }
}
</script>

<style scoped>

</style>
